import React, {useEffect, useState} from 'react';
import './NavbarNotification.scss';
import {t} from 'react-switch-lang';
import {Tab, Tabs} from 'react-bootstrap';
import TableWithUnreadNotification from './TableWithUnreadNotification';
import RowDropdown from '../tablesAdministration/Row-dropdown';
import {MarkAllNotificationAsRead} from '../modals/ModalMarkAllAsRead';
import {DeleteAllNotification} from '../modals/ModalDeleteAllNotifications';
import axios from 'axios';
import {BASE_URL} from '../../utils/const';
import TableWithDeleteNotification from './TableWithDeleteNotification';
import TableWithReadNotification from './TableWithReadNotification';

const NavbarNotification = ({numberNotification, client, connected}) => {
  const [key, setKey] = useState('unread');
  const [tableKey, setTableKey] = useState(1);
  const [unreadMessage, setUnreadMessage] = useState(false);
  const [readMessage, setReadMessage] = useState(false);

  const loadData = () => {
    axios
      .get(`${BASE_URL}/notifications/unread?page=0&sort=sentAt,desc`)
      .then((res) => {
        if (res.data.length !== 0) {
          setUnreadMessage(false);
          getDelivered();
        } else {
          getDelivered();
        }
      })
      .catch((r) => {
        setUnreadMessage(true);
      });

    axios
      .get(`${BASE_URL}/notifications/read?page=0`)
      .then((res) => {
        if (res.data.length !== 0) {
          setReadMessage(false);
        } else {
          setReadMessage(true);
        }
      })
      .catch((r) => {
        setReadMessage(true);
      });
  };

  const getDelivered = () => {
    axios
      .get(`${BASE_URL}/notifications/delivered?page=0&sort=sentAt,desc`)
      .then((res) => {
        if (res.data.length !== 0) {
          setUnreadMessage(false);
        } else {
          setUnreadMessage(true);
        }
      })
      .catch((r) => {
        setUnreadMessage(true);
      });
  };

  useEffect(() => {
    loadData();
  }, []);

  const onRowChange = () => {
    setTableKey(tableKey + 1);
    loadData();
  };

  return (
    <div className="navbarNotification">
      <div className="text-left navHeader pr-80">
        <h1>{t('dashboard.notification')} </h1>
      </div>
      <Tabs
                id="controlled-tab-example"
                activeKey={key}
                onSelect={(k) => setKey(k)}
            >
                <Tab eventKey="unread" title="">
                    <div className="d-flex notificationTab">
                        <h2 className="tabHeader">
                            {t('notification.unreadMessage')}
                        </h2>
                        {unreadMessage
                            ? ""
                            : <RowDropdown
                                buttons={[
                                    <MarkAllNotificationAsRead
                                        setRowChanged={() => onRowChange()}/>,
                                    <DeleteAllNotification type="delivered"
                                                           setRowChanged={() => onRowChange()}/>
                                ]}
                                hide={false}
                            />
                        }

                    </div>
                    {key === "unread" &&
                    <TableWithUnreadNotification
                        message="unread"
                        setRowChanged={() => onRowChange()}
                        key={tableKey}
                    />
                    }

                </Tab>
                <Tab eventKey="read" title="">
                    <div className="d-flex notificationTab">
                        <h2 className="tabHeader">
                            {t('notification.readMessage')}
                        </h2>
                        {readMessage
                            ? ""
                            : <RowDropdown
                                buttons={[
                                    <DeleteAllNotification type="read"
                                                           setRowChanged={() => onRowChange()}/>
                                ]}
                                hide={false}
                            />
                        }

                    </div>
                    {key === "read" &&
                    <TableWithReadNotification
                        message="read"
                        setRowChanged={() => onRowChange()}
                        key={tableKey}
                    />
                    }
                </Tab>
                <Tab eventKey="delete" title="">
                    <h2 className="tabHeader">
                        {t('notification.deletedMessage')}
                    </h2>
                    {key === "delete" &&
                    <TableWithDeleteNotification
                        message="deleted"
                        setRowChanged={() => onRowChange()}
                        key={tableKey}
                    />
                    }
                </Tab>
            </Tabs>
    </div>
  );
};

export default NavbarNotification;
